import isBoolean from "lodash/isBoolean";
import isEmpty from "lodash/isEmpty";
import uniq from "lodash/uniq";
import { Checkbox } from "PFComponents/checkbox/checkbox";
import { Inline, Stack } from "PFComponents/containers";
import { areValuesEqual } from "PFCore/helpers/filters";
import { useBooleanToString } from "PFCore/hooks/use_boolean_to_string";
import { FilterValueV2 } from "PFTypes/filters_v2";

import { letFilterRestore } from "../../use_filtered_collection";
import css from "./checkboxes_item.module.scss";
import { ExpandedFilterParams } from "./components/expanded_filter_wrapper";
import { FilterHeader } from "./components/filter_header";

export const CheckboxesItem = ({ filter, onChange, disabled, options }: ExpandedFilterParams) => {
  const filterValue = (filter.value || []) as number[];
  const canRestore = letFilterRestore(filter);
  const canClear = !isEmpty(filterValue) && !filter.required;
  const booleanToString = useBooleanToString();

  return (
    <Stack gap="spacingMd">
      <FilterHeader
        filter={filter}
        disabled={disabled}
        canClear={canClear}
        canRestore={canRestore}
        onChange={onChange}
      />
      {options.length > 0 && (
        <Inline wrap="wrap">
          {options.map((option) => {
            const checked = !!filterValue.find((value) => value === option.id);
            const label = isBoolean(option.value)
              ? booleanToString(option.value)
              : option.displayElement || option.value;
            const isDefaultValueSelected = areValuesEqual(
              filter.value as FilterValueV2,
              filter.defaultValue as FilterValueV2
            );

            const isDisabled =
              disabled || (filter.required && isDefaultValueSelected && checked && filterValue.length === 1);

            return (
              <Checkbox
                className={css.checkbox}
                disabled={isDisabled}
                key={option.id}
                label={label}
                checked={checked}
                onChange={(checked) => {
                  const newValues = checked
                    ? uniq([...filterValue, option.id])
                    : filterValue.filter((value) => value !== option.id);
                  onChange(newValues);
                }}
              />
            );
          })}
        </Inline>
      )}
    </Stack>
  );
};
